import { IConsumer, IEvent, createConsumer, createSubscriber } from '@cian/events-log';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getComplaints } from 'shared/thunks/complaint';
import { IComplain } from 'shared/types/complaint';
import { IOffer } from 'shared/types/offers';
import { IAppState, TThunkDispatch } from 'shared/types/redux';

let consumer: IConsumer;

type TUseModerationComplaintProps = {
  onCloseModal(): void;
  offer: IOffer;
};

//instanbul ignore next
export const useModerationComplaint = ({ onCloseModal, offer }: TUseModerationComplaintProps) => {
  const { isError, manifest } = useSelector<IAppState, IComplain>(state => state.complain);

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<TThunkDispatch>();

  /* istanbul ignore next */
  const complaintsSubscriber = createSubscriber((event: IEvent<unknown>) => {
    if (event.type === 'popup_close') {
      onCloseModal();
    }
  });

  const effectHandler = (): void => {
    consumer ??= createConsumer({ topic: 'complaintsModal' });
    consumer.subscribe(complaintsSubscriber);
  };

  useEffect(() => {
    if (!manifest) {
      dispatch(getComplaints());
    } else {
      setIsLoading(false);
    }
    effectHandler();

    return () => {
      consumer.unsubscribe(complaintsSubscriber);
    };
  });

  const refetch = () => {
    setIsLoading(true);
    dispatch(getComplaints());
  };

  return {
    isLoading,
    refetch,
    manifest,
    offerId: offer.id || 0,
    isError,
  };
};
